
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/express-policy-changes/remove-vehicle",
      function () {
        return require("private-next-pages/g/express-policy-changes/remove-vehicle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/express-policy-changes/remove-vehicle"])
      });
    }
  